import ImageCard from "./ImageCard";
import { useGetAllMediaQuery } from "../../Redux/getApi";

const Media = () => {
  const { data, error, isLoading, isFetching } = useGetAllMediaQuery();
  const getVideoId = (url) => {
    const withoutPrefix = url.replace("https://youtu.be/", "");
    return withoutPrefix;
  };

  const loading = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  return (
    <div className="flex flex-col  bg-white md:bg-[#F6F6F6]  lg:gap-10 md:gap-6 gap-4 xl:py-20 lg:py-14 sm:py-10 py-6 xl:px-[5%] lg:px-[3%] md:px-[3%] px-[6%] ">
      <div className="lg:text-[2.5rem] text-[2rem] font-bold text-center">
        Media Gallery
      </div>
      {isLoading || isFetching ? (
        <div className="flex flex-col lg:gap-10 md:gap-6 gap-4  w-full">
          <div className="relative aspect-[1/.4] w-full bg-[#EFEFEF] animate-pulse rounded-2xl"></div>
          <div className=" grid xl:grid-cols-3 md:grid-cols-2 grid-cols-1 lg:gap-3 gap-2">
            {loading.map((i) => (
              <div
                key={i}
                className="bg-[#EFEFEF] w-full  relative aspect-[3/2] rounded-xl animate-pulse"
              >
                <div className="absolute bottom-5 bg-[#97979750] rounded-lg z-20 w-[95%] mx-[2.5%] h-6"></div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <>
          {data?.video?.length === 0 && data?.image?.length === 0 ? (
            <p className="text-center w-full lg:text-[3rem] md:text-[2rem] text-[1.4rem] font-semibold text-[#000000]">
              No media available at the moment.
            </p>
          ) : (
            <>
            <div className=" grid md:grid-cols-2 grid-cols-1 gap-6 ">

              {data?.video?.map((vid, i) => (
                <div key={i} className="relative aspect-video w-full">
                  <iframe
                    className="absolute top-0 left-0 w-full h-full rounded-xl"
                    src={`https://www.youtube.com/embed/${getVideoId(
                      vid?.youtubeVideo
                    )}&controls=0`}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                    ></iframe>
                </div>
              ))}
              </div>

              <div className="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-6">
                {data?.image?.map((image) => (
                  <div key={image?._id} className="w-full flex">
                    <ImageCard image={image} />
                  </div>
                ))}
              </div>
            </>
          )}
        </>
      )}

      {error && (
        <p className=" text-red-500 text-center md:text-[1rem] text-sm bg-red-100 p-2 rounded-lg">
          {error?.data?.message || error?.data?.error}
        </p>
      )}
    </div>
  );
};

export default Media;
